/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './regimen-drug.reducer';

export const RegimenDrugDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const regimenDrugEntity = useAppSelector(state => state.regimenDrug.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="regimenDrugDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.regimenDrug.detail.title">RegimenDrug</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.regimenDrug.id">Id</Translate>
            </span>
          </dt>
          <dd>{regimenDrugEntity.id}</dd>
          <dt>
            <span id="drugClass">
              <Translate contentKey="tinyMedicRestApp.regimenDrug.drugClass">Drug Class</Translate>
            </span>
          </dt>
          <dd>{regimenDrugEntity.drugClass}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.regimenDrug.active">Active</Translate>
            </span>
          </dt>
          <dd>{regimenDrugEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.regimenDrug.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{regimenDrugEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.regimenDrug.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{regimenDrugEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.regimenDrug.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{regimenDrugEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.regimenDrug.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{regimenDrugEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenDrug.drug">Drug</Translate>
          </dt>
          <dd>{regimenDrugEntity.drug ? regimenDrugEntity.drug.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenDrug.frequency">Frequency</Translate>
          </dt>
          <dd>{regimenDrugEntity.frequency ? regimenDrugEntity.frequency.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenDrug.sequence">Sequence</Translate>
          </dt>
          <dd>{regimenDrugEntity.sequence ? regimenDrugEntity.sequence.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenDrug.dose">Dose</Translate>
          </dt>
          <dd>{regimenDrugEntity.dose ? regimenDrugEntity.dose.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenDrug.cycle">Cycle</Translate>
          </dt>
          <dd>{regimenDrugEntity.cycle ? regimenDrugEntity.cycle.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenDrug.medicationType">Medication Type</Translate>
          </dt>
          <dd>{regimenDrugEntity.medicationType ? regimenDrugEntity.medicationType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/regimen-drug" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/regimen-drug/${regimenDrugEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RegimenDrugDetail;
